export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49'),
	() => import('./nodes/50'),
	() => import('./nodes/51'),
	() => import('./nodes/52'),
	() => import('./nodes/53'),
	() => import('./nodes/54'),
	() => import('./nodes/55'),
	() => import('./nodes/56'),
	() => import('./nodes/57'),
	() => import('./nodes/58'),
	() => import('./nodes/59'),
	() => import('./nodes/60'),
	() => import('./nodes/61'),
	() => import('./nodes/62'),
	() => import('./nodes/63')
];

export const server_loads = [];

export const dictionary = {
		"/(app)": [13,[2]],
		"/(app)/admin/settings": [14,[2]],
		"/auth": [60],
		"/(code)/code": [48,[11]],
		"/(code)/code/[id]": [49,[11]],
		"/(app)/c/[id]": [15,[2]],
		"/error": [61],
		"/forms/[slug]": [62],
		"/(app)/image-gen": [16,[2]],
		"/(app)/integrations": [17,[2]],
		"/(app)/integrations/failed": [18,[2]],
		"/(app)/integrations/success": [19,[2]],
		"/(app)/meetings": [20,[2]],
		"/(app)/notetaker": [21,[2,3]],
		"/(app)/notetaker/calendar-success": [22,[2,3]],
		"/(app)/orchestra": [23,[2,4]],
		"/(app)/playground": [24,[2,5]],
		"/(app)/previous-meetings": [25,[2]],
		"/(app)/project": [26,[2,6]],
		"/(app)/project/[id]": [27,[2,6,7]],
		"/(app)/smart-calendar": [28,[2]],
		"/(app)/social-media": [29,[2]],
		"/(app)/success/google": [30,[2]],
		"/(app)/success/google/error": [31,[2]],
		"/s/[id]": [63],
		"/(tasks)/tasks": [50,[12]],
		"/(tasks)/tasks/all": [51,[12]],
		"/(tasks)/tasks/inbox": [52,[12]],
		"/(tasks)/tasks/issue/[ref]": [53,[12]],
		"/(tasks)/tasks/my": [54,[12]],
		"/(tasks)/tasks/preferences": [56,[12]],
		"/(tasks)/tasks/p/[id]": [55,[12]],
		"/(tasks)/tasks/settings": [57,[12]],
		"/(tasks)/tasks/triage": [58,[12]],
		"/(tasks)/tasks/v/[id]": [59,[12]],
		"/(app)/task": [32,[2,8]],
		"/(app)/users": [33,[2,9]],
		"/(app)/workspace": [34,[2,10]],
		"/(app)/workspace/documents": [35,[2,10]],
		"/(app)/workspace/functions": [36,[2,10]],
		"/(app)/workspace/functions/create": [37,[2,10]],
		"/(app)/workspace/functions/edit": [38,[2,10]],
		"/(app)/workspace/models": [39,[2,10]],
		"/(app)/workspace/models/create": [40,[2,10]],
		"/(app)/workspace/models/edit": [41,[2,10]],
		"/(app)/workspace/prompts": [42,[2,10]],
		"/(app)/workspace/prompts/create": [43,[2,10]],
		"/(app)/workspace/prompts/edit": [44,[2,10]],
		"/(app)/workspace/tools": [45,[2,10]],
		"/(app)/workspace/tools/create": [46,[2,10]],
		"/(app)/workspace/tools/edit": [47,[2,10]]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
};

export { default as root } from '../root.svelte';